import "./Loader.scss";
import loaderGif from "@/assets/icons/loader.gif";

export const Loader: React.FC = () => {
  return (
    <div className="loader" aria-busy="true" aria-label="Chargement en cours">
      <img src={loaderGif} alt="" className="loader-spinner" />
    </div>
  );
};
